<template>
    <div>
        <div class="message-bar" :style="{ paddingTop: titlePadding + 'px' }">
            <div class="icon_back-box">
                <img v-if="showBack" @click="backHandle" class="message-icon_back" src="@/assets/instantMessaging/ic_back.svg"/>
            </div>
            <span class="message-title">
            <template v-if="type == 1">
                <img class="message-icon_title" src="@/assets/instantMessaging/ic_talking_green.svg"/>
            </template>
            {{title}}
        </span>
            <div v-if="rightIcon"
                 @click="rightIconHandle"
                 class="message-icon_right">
                <template v-if="rightIcon === 'person'">
                    <img src="@/assets/instantMessaging/ic_person.svg"/>
                </template>
            </div>
        </div>
        <template v-if="isRefund">
            <div class="return-order"
                 @click="isActive = !isActive">
                <img src="@/assets/instantMessaging/ic_commodity.svg" class="order-icon"/>
                <div class="order-content">
                    <span class="order-title">当前退货商品：</span>
                    <span class="order-info" v-if="refundInfo.shopList.length > 0">{{refundInfo.shopList | shopName}}</span>
                    <span class="order-info" v-else>{{refundDetails.product}}</span>
                </div>
                <img src="@/assets/instantMessaging/ic_arrow_down.svg" class="order-icon fl-r"
                     :aria-expanded="isActive"/>
            </div>
            <div class="return-order-detail" :style="!isActive && { height: 0,paddingBottom: 0 }">
                <div class="return-order-container">
                    <div class="order-ceil">
                        <div class="order-label">
                            <span class="order-title">预计退款金额：</span>
                        </div>
                        <span class="order-info">￥{{shoppingAmount || refundDetails.shoppingAmount}}</span>
                    </div>
                    <div class="order-ceil">
                        <div class="order-label">
                            <span class="order-title">申请日期：</span>
                        </div>
                        <span class="order-info">{{refundInfo.refundTime || refundDetails.refundTime | filt}}</span>
                    </div>
                    <div class="order-ceil">
                        <div class="order-label">
                            <span class="order-title">销售企业：</span>
                        </div>
                        <span class="order-info">{{refundInfo.shoppingStore || refundDetails.store}}</span>
                    </div>
                    <div class="order-ceil">
                        <div class="order-label">
                            <span class="order-title">退货渠道：</span>
                        </div>
                        <span class="order-info">{{getReturnChannel(refundInfo.refundChannel || refundDetails.refundChannelText)}}</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import refundApi from "@/service/modules/refund";
import api from '@/service/modules/instantMessaging';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
export default {
    name: "titleBar",
	components: {},
	directives: {},
	filters: {
	    shopName(shopList) {
	        const nameList = shopList.map(item => item.itemName);
	        return nameList.join(',');
	    },
		filt(value) {
			return moment(value).format("YYYY/MM/DD");
		},
	},
	model: {},
	props: {
	    title: String,
	    type: {
	        type: [String, Number],
		    default: 0
	    },
	    rightIcon: {
		    type: [String, Boolean],
		    default: false
	    },
	    showBack: {
	        type: Boolean,
		    default: true
	    }
	},
	data() {
	    return {
	        isActive: false,
	        refundInfo: {
		        refundChannel: '',
		        shoppingStore: '',
		        refundTime: '',
                shopList: []
	        },
		    refundDetails: {
			    product: '',
			    store: '',
			    shoppingAmount: 0,
			    refundChannel: '',
			    refundChannelText: '',
			    refundTime: ''
		    },
		    dictType: "",
		    titlePadding: 40
	    }
	},
	computed: {
        ...mapState('instantMessaging', ['currentConversation']),
        ...mapGetters('instantMessaging', ['toAccount', 'isCustom']),
        isRefund: function () {
            const isRefund = this.toAccount && this.toAccount.includes('REFUND-');
            if (isRefund) {
	            if (this.isCustom) {
	                this.getRefundDetail();
	            } else {
		            this.getRefundInfo();
	            }
            }
            return isRefund;
        },
		shoppingAmount: function () {
            if (this.refundInfo.shopList.length === 0) {
                return 0
            }
            let num = 0;
            this.refundInfo.shopList.forEach(item => {
	            num += (item.amount * item.num)
            });
            return num;
		}
	},
	beforeCreate() {},
	created() {
		this.setTitlePadding();
	},
	beforeMount() {},
	mounted() {},
	beforeUpdate() {},
	updated() {},
	activated() {},
	deactivated() {},
	beforeDestroy() {},
    destroyed() {},
    methods: {
	    rightIconHandle() {
	        this.$emit('iconClick')
	    },
	    async getRefundInfo() {
	        await this.getDictType();
	        const conversationID = this.currentConversation.conversationID;
		    refundApi.detailList({
		        number: conversationID.replace('GROUPREFUND-', '')
             }).then(res => {
			    const data = res.data;
			    this.refundInfo = {
                    shopList: data.itemList,
                    refundChannel: data.detail.refundChannel,
                    shoppingStore: data.detail.shoppingStore,
                    refundTime: data.detail.refundTime,
			    }
		    })
	    },
	    // 获取基础枚举
	    getDictType() {
		    refundApi.typePicker().then(res => {
			    if (res.ret === 0) {
				    if (res.data && res.data.REFUND_CHANNEL) {
					    this.dictType = res.data.REFUND_CHANNEL;
				    }
			    }
		    });
	    },
	    // 退货渠道
	    getReturnChannel(val) {
		    let name = "";
		    if (this.dictType) {
			    this.dictType.map(item => {
				    if (item.code === val) {
					    name = item.name;
				    }
			    });
		    }
		    return name || val;
	    },
	    backHandle() {
		    this.$router.go(-1);
	    },
	    getRefundDetail() {
		    const conversationID = this.currentConversation.conversationID;
	        api.refundDetails({
		        number: conversationID.replace('GROUPREFUND-', '')
	        }).then(res => {
		        const data = res.data;
		        this.refundDetails = {
			        product: data.product,
			        shoppingAmount: data.shoppingAmount,
			        refundChannel: data.refundChannel,
			        refundChannelText: data.refundChannelText,
			        store: data.store,
			        refundTime: data.refundTime,
		        }
	        });
	    },
	    setTitlePadding() {
		    let u = navigator.userAgent;
		    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		    if (isiOS) {
		        this.titlePadding = 30;
		    }
	    }
    }
}
</script>

<style scoped lang="less">
.message-bar {
    height: 44px;
    width: 100%;
    /*padding: 0 12px 0 16px;*/
    display: flex;
    align-items: center;
    background-color: #fff;
    /* 适配齐刘海*/
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    box-sizing: content-box;
    .icon_back-box {
        padding-left: 12px;
        padding-right: 20px;
        .message-icon_back {
            width: 16px;
            height: 16px;
            // margin-left: 12px;
        }
    }

    .message-title {
        margin: auto;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: #171A1D;
        line-height: 16px;
        font-size: 16px;
        display: flex;
        align-items: center;
        transform: translateX(-10px);

        .message-icon_title {
            width: 24px;
            height: 24px;
            margin-right: 4px;
        }
    }

    .message-icon_right {
        width: 24px;
        height: 24px;
        margin-right: 16px;
    }
}

.return-order {
    height: 51px;
    display: flex;
    align-items: center;
    padding: 14px 12px 14px 16px;
    background-color: #FFF;

    .order-icon {
        width: 16px;
        height: 16px;
        transition: all 0.5s ease-in-out;
    }

    .order-icon[aria-expanded=true] {
        transform: rotate(180deg);
    }
}

.return-order-detail {
    transition: all 0.3s ease-in-out;
    padding: 0 16px 20px;
    display: flex;
    overflow: hidden;
    background-color: #fff;

    .return-order-container {
        padding-top: 1.5px;
        border-top: 1px solid #F1F2F5;
        overflow: hidden;

        .order-ceil {
            margin-top: 10px;
            display: flex;

            .order-label {
                width: 100px;
            }
        }
    }
}

.order-content {
    margin-left: 6px;
    display: flex;
}

.order-title {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #71747A;
    letter-spacing: 0;
    line-height: 16px;
}

.order-info {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #1E2226;
    letter-spacing: 0;
    line-height: 16px;
    max-width: 14em;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.fl-r {
    margin-left: auto;
}
</style>
